import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import VerticalNavFunction from "./VerticalNavFunction";
import { setEnableMobileMenu } from "../../reducers/ThemeOptions";
import {
  MainNav,
  StatusComponent,
} from "./NavItems";

class Nav extends Component {
  state = {
    pipeline: StatusComponent,
    menu: MainNav
  };


  toggleMobileSidebar = () => {
    let { enableMobileMenu, setEnableMobileMenu } = this.props;
    setEnableMobileMenu(!enableMobileMenu);
  };


  render() {
    return (
      <Fragment>
        <VerticalNavFunction toggleMobileSidebar={this.toggleMobileSidebar} />
      </Fragment>
    );
  }

  isPathActive(path) {
    return this.props.location.pathname.startsWith(path);
  }
}
const mapStateToProps = (state) => ({
  enableMobileMenu: state.ThemeOptions.enableMobileMenu,
});

const mapDispatchToProps = (dispatch) => ({
  setEnableMobileMenu: (enable) => dispatch(setEnableMobileMenu(enable)),
});
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Nav));
